export const BREAK_POINT = {
  mobile: "600px",
  tablet: "1024px",
  desktop: "1440px",
};
